export const FirebaseConfig = {
	"projectId": "lubber-driver",
	"appId": "1:387473047278:web:dd4487dfd2b534ba30fdff",
	"databaseURL": "https://lubber-driver-default-rtdb.firebaseio.com",
	"storageBucket": "lubber-driver.firebasestorage.app",
	"apiKey": "AIzaSyB8pUOZ9_5Q3T1JiiaWalLn7FTZcAdW6oE",
	"authDomain": "lubber-driver.firebaseapp.com",
	"messagingSenderId": "387473047278",
	"measurementId": "G-11HM93G0CT"
};